import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Row, UncontrolledTooltip} from "reactstrap";
import {AuthPageType, eCommerces} from "../helper/enums";
import {request} from "../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../helper/helper";
import {isValidDbsAuth, isValidTurmobAuth, isValidUtsAuth} from "../common/componentValidation";
import Alert from "react-s-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import InformationCard from "../components/InformationCard";
import {type} from "ramda";

class AuthPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            title: this.props.type === AuthPageType.UTS ? "ÜTS token bilgisi"
                : (this.props.type === AuthPageType.TURMOB ? "TÜRMOB token bilgisi"
                    : (this.props.type === AuthPageType.DBS ? "DBS giriş bilgileri"
                        : (this.props.type === AuthPageType.INTERAKTIFVD ? "İnteraktif V.D giriş bilgileri"
                            : (this.props.type === AuthPageType.CICEKSEPETI ? "Çiçek Sepeti giriş bilgileri"
                                : (this.props.type === AuthPageType.TRENDYOL ? "Trendyol Entegrasyon bilgileri"
                                    : (this.props.type === AuthPageType.N11 ? "N11 Entegrasyon bilgileri"
                                        : (this.props.type === AuthPageType.PAZARAMA ? "Pazarama Entegrasyon bilgileri"
                                            : (this.props.type === AuthPageType.IKAS ? "IKAS Entegrasyon bilgileri"
                                                : (this.props.type === AuthPageType.HEPSIBURADA ? "Hepsiburada Entegrasyon bilgileri" : "")))))))))
        };
    }

    componentDidMount() {
        this.fetch();
        if (this.props.type === AuthPageType.DBS && !this.state.data.recordId) {
            this.setState({
                data: {
                    loginType: 'ASSOS'
                }
            });
        }
    }

    fetch = () => {
        let self = this;
        let params;
        if (self.props.type === AuthPageType.HEPSIBURADA || self.props.type === AuthPageType.IKAS ||
            self.props.type === AuthPageType.TRENDYOL || self.props.type === AuthPageType.CICEKSEPETI ||
            self.props.type === AuthPageType.N11 || self.props.type === AuthPageType.PAZARAMA) {
            params = {
                url: self.props.type.fetchUrl + `/${self.props.type === AuthPageType.CICEKSEPETI ? eCommerces.CICEKSEPETI :
                    (self.props.type === AuthPageType.TRENDYOL ? eCommerces.TRENDYOL : 
                        (self.props.type === AuthPageType.PAZARAMA ? eCommerces.PAZARAMA : 
                            (self.props.type === AuthPageType.IKAS ? eCommerces.IKAS : 
                                (self.props.type === AuthPageType.HEPSIBURADA ? eCommerces.HEPSIBURADA : eCommerces.N11))))}`,
                method: "get"
            };
        } else {
            params = {
                url: self.props.type.fetchUrl,
                method: "get"
            };
        }
        request(params)
            .then(function (response) {
                if (response.data) {
                    self.setState({data: response.data});
                }
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    onChangeData = (name, value) => {
        let data = deepCopyObject(this.state.data);
        data[name] = value;
        this.setState({data: data});
    }

    save = () => {
        let self = this;
        let data = deepCopyObject(self.state.data);

        let result;
        switch (self.props.type) {
            case AuthPageType.TRENDYOL:
            case AuthPageType.DBS:
            case AuthPageType.IKAS:
            case AuthPageType.INTERAKTIFVD:
            case AuthPageType.HEPSIBURADA:
            case AuthPageType.N11:
            case AuthPageType.PAZARAMA:
            case AuthPageType.CICEKSEPETI:
                result = isValidDbsAuth(data, self.props.type)
                break;
            case AuthPageType.UTS:
                result = isValidUtsAuth(data);
                break;
            case AuthPageType.TURMOB:
                result = isValidTurmobAuth(data);
                break;
        }

        if (result.valid) {
            let params;
            if (AuthPageType.TRENDYOL || AuthPageType.CICEKSEPETI || AuthPageType.HEPSIBURADA || AuthPageType.N11 || AuthPageType.PAZARAMA || AuthPageType.IKAS){
                data = {
                    recordId: data.recordId,
                    customerId: data.customerId,
                    userId: data.userId,
                    supplierId: data.supplierId,
                    apiKey: data.apiKey,
                    apiSecret: data.apiSecret,
                    createdAt: data.createdAt,
                    updatedAt: data.updatedAt,
                    customerBranchId: data.customerBranchId,
                    token: data.token,
                    username: data.username,
                    password: data.password,
                    ecommerceName: self.props.type === AuthPageType.CICEKSEPETI ? eCommerces.CICEKSEPETI :
                        (self.props.type === AuthPageType.TRENDYOL ? eCommerces.TRENDYOL :
                            (self.props.type === AuthPageType.PAZARAMA ? eCommerces.PAZARAMA :
                                (self.props.type === AuthPageType.IKAS ? eCommerces.IKAS :
                                    (self.props.type === AuthPageType.HEPSIBURADA ? eCommerces.HEPSIBURADA : eCommerces.N11))))
                }
                params = {
                    url: self.props.type.saveUrl,
                    method: "post",
                    data: data
                };
            } else {
                params = {
                    url: self.props.type.saveUrl,
                    method: "post",
                    data: data
                };
            }

            request(params)
                .then(function (response) {
                    if (response.data) {
                        Alert.success("Kaydetme işlemi başarılı.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                        self.setState({data: response.data});
                    }
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    delete = () => {
        let self = this;
        let params = {
            url: self.props.type.deleteUrl,
            method: "post",
            data: self.state.data
        };

        if (self.props.type === AuthPageType.INTERAKTIFVD &&
            self.state.data && self.state.data.token !== null) {
            self.signOut();
        }

        request(params)
            .then(function (response) {
                Alert.success(self.state.title + " silme işlemi başarılı şekilde gerçekleşti.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                if (self.props.type === AuthPageType.DBS) {
                    self.setState({
                        data: {
                            loginType: 'ASSOS'
                        }
                    });
                } else {
                    self.setState({data: {}});
                    if (self.props.type === AuthPageType.TRENDYOL) {
                        self.onChangeData("apiKey", "");
                        self.onChangeData("supplierId", "");
                        self.onChangeData("apiSecret", "");
                    }
                }
            }).catch(function (error) {
            Alert.error("Silme işlemi gerçekleşmedi!!!", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
            showAxiosError(error);
        });
        self.setState({alert: null});
    }

    signOut = () => {
        let self = this;
        let params = {
            url: self.props.type.signOutUrl,
            method: "post"
        };
        request(params).then(function (response) {
            self.setState({data: response.data});
            Alert.success("Güvenli çıkış yapıldı.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }).catch(function (error) {
            if (error.message === "") {
                Alert.error("Güvenli çıkış yapılamadı!!!", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            }
            showAxiosError(error);
        });
    }

    render() {
        return (
            <Row className="FormRenk"
                 style={{marginLeft: '0px', paddingLeft: '0px', marginRight: "0px", paddingTop: '30px'}}>
                {this.props.type === AuthPageType.CICEKSEPETI &&
                    <Col sm="12">
                        <FormGroup row>
                            <p>
                                <Label sm={8}>APi Key'inizi bilmiyor iseniz Çiçeksepeti satıcı panelinizden Mesajlar > Çiçeksepeti Destek Ekibine Sorun sayfasında Yeni Konuşma Başlat dedikten sonra API işlemlerini seçerek destek isteyebilirsiniz.</Label>
                            </p>
                            <Col sm={4}/>
                        </FormGroup>
                    </Col>
                }
                {this.props.type === AuthPageType.UTS &&
                <Col sm="12">
                    <FormGroup row>
                        <Label sm={2}>ÜTS'den Alınan Token Bilgisi</Label>
                        <Col sm={4}>
                            <Input type="text"
                                   id="token"
                                   className="form-control"
                                   style={{border: '0.1em solid #000'}}
                                   placeholder="Ürün Kayıt Sistemi Token Bilgisi"
                                   value={this.state.data && this.state.data.token ? this.state.data.token : ''}
                                   onChange={(e) => this.onChangeData("token", e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                </Col>
                }

                {this.props.type === AuthPageType.TURMOB &&
                <Col sm="12">
                    <FormGroup row>
                        <Label sm={2}>TÜRMOB'dan Alınan Token Bilgisi</Label>
                        <Col sm={4}>
                            <Input type="password"
                                   id="token"
                                   className="form-control"
                                   style={{border: '1px solid grey', fontSize: '20px', padding: 0, margin: 0}}
                                   placeholder="*"
                                   value={this.state.data && this.state.data.token ? this.state.data.token : ''}
                                   onChange={(e) => this.onChangeData("token", e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                </Col>
                }

                {this.props.type === AuthPageType.DBS &&
                    <div className="col-12">
                        <div className="d-flex justify-content-sm-center align-items-center shadow-none">
                            <label className="my-0 mr-1">Detaylı Bilgi İçin Tıklayınız </label>
                            <InformationCard
                                header={"Defter Beyan Hakkında Detaylı Bilgi"}/>
                        </div>
                        <div className="horizontalLine mt-2 mb-4"/>

                    </div>
                }


                {[AuthPageType.DBS, AuthPageType.INTERAKTIFVD, AuthPageType.CICEKSEPETI, AuthPageType.TRENDYOL, AuthPageType.IKAS, AuthPageType.HEPSIBURADA, AuthPageType.N11, AuthPageType.PAZARAMA].includes(this.props.type) &&
                <Col sm={12} className="row">
                    {((this.props.type === AuthPageType.DBS && this.state.data && this.state.data.loginType === 'ASSOS')
                            || this.props.type === AuthPageType.INTERAKTIFVD || this.props.type === AuthPageType.HEPSIBURADA
                            || this.props.type === AuthPageType.IKAS) &&
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>{this.props.type !== AuthPageType.IKAS ? "Kullanıcı Adı" : "Mağaza Adı"}</Label>
                            <Col sm={8}>
                                <Input type="text"
                                       id="username"
                                       className="form-control"
                                       style={{border: '0.1em solid #000'}}
                                       placeholder={this.props.type !== AuthPageType.HEPSIBURADA ? "İnteraktif Vergi Dairesi Kullanıcı Kodu" : "Hepsiburada Kullanıcı Adı"}
                                       value={this.state.data && this.state.data.username ? this.state.data.username : ''}
                                       onChange={(e) => this.onChangeData("username", e.target.value)}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    }

                    {((this.props.type === AuthPageType.DBS && this.state.data && this.state.data.loginType === 'ASSOS') || this.props.type === AuthPageType.INTERAKTIFVD || this.props.type === AuthPageType.HEPSIBURADA) &&
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>Şifre</Label>
                            <Col sm={8}>
                                <Input type="password"
                                       id="password"
                                       className="form-control"
                                       style={{border: '0.1em solid #000'}}
                                       placeholder={this.props.type !== AuthPageType.HEPSIBURADA ? "İnteraktif Vergi Dairesi Şifresi" : "Hepsiburada Şifresi"}
                                       value={this.state.data && this.state.data.password ? this.state.data.password : ''}
                                       onChange={(e) => this.onChangeData("password", e.target.value)}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    }


                    {((this.props.type === AuthPageType.DBS && this.state.data && this.state.data.loginType === 'API') ||
                            this.props.type === AuthPageType.CICEKSEPETI || this.props.type === AuthPageType.TRENDYOL ||
                            this.props.type === AuthPageType.N11 || this.props.type === AuthPageType.PAZARAMA) &&
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>Api Key</Label>
                            <Col sm={8}>
                                <Input type="text"
                                       id="apiKey"
                                       style={{border: '0.1em solid #000'}}
                                       className="form-control"
                                       placeholder={(AuthPageType.DBS ? "Dış sistem " : "") +  "Api Key Bilgisi"}
                                       value={this.state.data ? this.state.data.apiKey : ''}
                                       onChange={(e) => this.onChangeData("apiKey", e.target.value)}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    }

                    {((this.props.type === AuthPageType.DBS && this.state.data && this.state.data.loginType === 'API') ||
                            this.props.type === AuthPageType.TRENDYOL || this.props.type === AuthPageType.N11 || this.props.type === AuthPageType.IKAS || this.props.type === AuthPageType.PAZARAMA) &&
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>Api Secret Bilgisi</Label>
                            <Col sm={8}>
                                <Input type="text"
                                       id="apiSecret"
                                       style={{border: '0.1em solid #000'}}
                                       className="form-control"
                                       placeholder="Dış sistem Api Secret bilgisi"
                                       value={this.state.data ? this.state.data.apiSecret : ''}
                                       onChange={(e) => this.onChangeData("apiSecret", e.target.value)}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    }
                    {(this.props.type === AuthPageType.TRENDYOL || this.props.type === AuthPageType.IKAS || this.props.type === AuthPageType.HEPSIBURADA) &&
                        <Col sm="6">
                            <FormGroup row>
                                <Label sm={4}> {this.props.type === AuthPageType.TRENDYOL ? "Supplier Id Bilgisi" : "Mağaza Id Bilgisi"}</Label>
                                <Col sm={8}>
                                    <Input type="text"
                                           id="supplierId"
                                           style={{border: '0.1em solid #000'}}
                                           className="form-control"
                                           placeholder="Dış sistem Supplier ID bilgisi"
                                           value={this.state.data ? this.state.data.supplierId : ''}
                                           onChange={(e) => this.onChangeData("supplierId", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    }
                </Col>
                }
                <Col sm="6">
                    <FormGroup row className="col-sm-12">
                        <Button className="TekBtn kaydet pull-right"
                                style={{marginRight: "10%"}}
                                onClick={() => this.save()}>
                            Kaydet
                        </Button>
                        <Button className="TekBtn delete bHizala mr-5"
                                disabled={this.state.data && !this.state.data.recordId}
                                onClick={e => {
                                    this.setState({
                                        alert: (
                                            <SweetAlert showCancel warning
                                                        confirmBtnText="Evet"
                                                        cancelBtnText="Hayır"
                                                        confirmBtnBsStyle="danger"
                                                        cancelBtnBsStyle="default"
                                                        title={this.state.title + "ni silmek istediğize emin misiniz?"}
                                                        onConfirm={() => {
                                                            this.delete()
                                                        }}
                                                        onCancel={() => this.setState({alert: null})}>
                                                {this.state.title + " silinecek devam edilsin mi?"}
                                            </SweetAlert>)
                                    })
                                }}>
                            Sil
                        </Button>
                        {this.props.type === AuthPageType.INTERAKTIFVD && this.state.data.token &&
                        <Button className="TekBtn kaydet pull-right"
                                style={{marginRight: "10%"}}
                                onClick={() => this.signOut()}>
                            Güvenli Çıkış
                        </Button>}
                    </FormGroup>
                </Col>
                {this.state.alert &&
                <div className="row satirBasi">
                    {this.state.alert}
                </div>
                }
            </Row>
        );
    }
}

export default AuthPage;